var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97136 11.1257C1.65516 8.92815 1.49706 7.82938 1.94744 6.88993C2.39782 5.95048 3.35646 5.37942 5.27373 4.23732L6.42776 3.54987C8.16884 2.51272 9.03938 1.99414 10.0013 1.99414C10.9632 1.99414 11.8338 2.51272 13.5748 3.54986L14.7289 4.23731C16.6461 5.37942 17.6048 5.95048 18.0552 6.88993C18.5055 7.82938 18.3474 8.92815 18.0312 11.1257L17.7989 12.7402C17.3928 15.563 17.1897 16.9744 16.2104 17.8176C15.2312 18.6608 13.7952 18.6608 10.923 18.6608H9.07957C6.20744 18.6608 4.77138 18.6608 3.79216 17.8176C2.81294 16.9744 2.60985 15.563 2.20367 12.7402L1.97136 11.1257Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 12.8271L10 15.3271",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon2);
export default __webpack_public_path__ + "static/media/DashboardIcon2.3b953f2441cc178d5784ad67176d0d8f.svg";
export { ForwardRef as ReactComponent };